import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AccountsGuideComponent } from './accounts-guide/accounts-guide.component';
import { AttendanceComponent } from './attendance/attendance.component';
import { BrokerComponent } from './broker/broker.component';
// import { CashPaymentsComponent } from './cash-payments/cash-payments.component';
// import { CashreceiptsComponent } from './cashreceipts/cashreceipts.component';
import { CategoryComponent } from './category/category.component';
import { ClientVisetorComponent } from './client-visetor/client-visetor.component';
import { QuotationComponent } from './quotation/quotation.component';
import { DailyrestrictionsComponent } from './dailyrestrictions/dailyrestrictions.component';
import { EmployeeComponent } from './employee/employee.component';
// import { GeneralReportsComponent } from './general-reports/general-reports.component';
import { Helpme } from './helpme';
import { HistoryComponent } from './history/history.component';
import { ItemsComponent } from './items/items.component';
import { OrderComponent } from './order/order.component';
import { PaymentComponent } from './payment/payment.component';
import { PaymentsReportComponent } from './payments-report/payments-report.component';
import { PaynoComponent } from './payno/payno.component';
import { PermissionComponent } from './permission/permission.component';
import { PrivateReortComponent } from './private-reort/private-reort.component';
import { PutmoneyComponent } from './putmoney/putmoney.component';
import { ReportsComponent } from './reports/reports.component';
import { RequestComponent } from './request/request.component';
import { ReturnComponent } from './return/return.component';
import { RootComponent } from './root/root.component';
import { SalaryComponent } from './salary/salary.component';
import { SellerComponent } from './seller/seller.component';
import { SheetComponent } from './sheet/sheet.component';
import { StoreComponent } from './store/store.component';
import { SupsuppliersComponent } from './supsuppliers/supsuppliers.component';
import { UsersComponent } from './users/users.component';
import { VisitComponent } from './visit/visit.component';
const routes: Routes = [
  {path: 'users', component: UsersComponent , canActivate: [Helpme], data: {name: 'Users'}},
  {path: 'root', component: RootComponent, canActivate: [Helpme], data: {name: 'Branches'}},
  {path: 'suppliers', component: SupsuppliersComponent, canActivate: [Helpme], data: {name: 'Suppliers'}},
  {path: 'items', component: ItemsComponent, canActivate: [Helpme], data: {name: 'Items'}},
  {path: 'category', component: CategoryComponent, canActivate: [Helpme], data: {name: 'Category'}},
  // {path: 'payno', component: PaynoComponent, canActivate: [Helpme], data: {name: 'Users'}},
  {path: 'quotations', component: QuotationComponent , canActivate: [Helpme], data: {name: 'Quotations'}},
  {path: 'request', component: RequestComponent, canActivate: [Helpme], data: {name: 'Request'}},
  {path: 'history', component: HistoryComponent, canActivate: [Helpme], data: {name: 'Histoty'}},
  // {path: 'operation', component: PaymentComponent, canActivate: [Helpme], data: {name: 'Users'}},
  {path: 'sheet', component: SheetComponent, canActivate: [Helpme], data: {name: 'Offer'}},
  {path: 'visit', component: VisitComponent, canActivate: [Helpme], data: {name: 'Customer'}},
  {path: 'sellers', component: SellerComponent , canActivate: [Helpme], data: {name: 'Sellers'}},
  {path: 'broker', component: BrokerComponent, canActivate: [Helpme], data: {name: 'Brokers'}},
  {path: 'order', component: OrderComponent, canActivate: [Helpme], data: {name: 'Orders'}},
  {path: 'store', component: StoreComponent, canActivate: [Helpme], data: {name: 'Store'}},
  {path: 'returns', component: ReturnComponent, canActivate: [Helpme], data: {name: 'Returns'}},
  {path: 'report', component: ReportsComponent , canActivate: [Helpme], data: {name: 'Reports'}},
  {path: 'visitClient', component: ClientVisetorComponent, canActivate: [Helpme], data: {name: 'Visit'}},
  {path: 'Employees', component: EmployeeComponent, canActivate: [Helpme], data: {name: 'Employees'}},
  {path: 'Attendances', component: AttendanceComponent, canActivate: [Helpme], data: {name: 'Attendances'}},
  {path: 'Salary', component: SalaryComponent, canActivate: [Helpme], data: {name: 'Salary'}},
  {path: 'Permession', component: PermissionComponent, canActivate: [Helpme], data: {name: 'Permession'}},
  // {path: 'AccountsGuide', component: AccountsGuideComponent , canActivate: [Helpme], data: {name: 'AccountsGuide'}},
  // {path: 'CashPayments', component: CashPaymentsComponent , canActivate: [Helpme], data: {name: 'CashPayments'}},
  // {path: 'CashReceipts', component: CashreceiptsComponent , canActivate: [Helpme], data: {name: 'CashReceipts'}},
  // {path: 'DailyRestrictions', component: DailyrestrictionsComponent , canActivate: [Helpme], data: {name: 'DailyRestrictions'}},
  // {path: 'GeneralReports', component: GeneralReportsComponent , canActivate: [Helpme], data: {name: 'GeneralReports'}},
  {path: 'PrivateReport', component: PrivateReortComponent , canActivate: [Helpme], data: {name: 'PrivateReport'}},
  {path: 'PaymentsReport', component: PaymentsReportComponent , canActivate: [Helpme], data: {name: 'PaymentsReport'}}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
